import { localReturnPath } from '@core/services/auth/keycloak-session.service';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { first, map } from 'rxjs';
import { selectAuth } from '@app/features/auth/auth.selectors';

function sessionGuard(
  page: 'application' | 'security-administrator' | 'no-access',
): CanActivateFn {
  return (_route, target) => {
    const router = inject(Router);
    return inject(Store)
      .select(selectAuth)
      .pipe(
        first((state) => state.init),
        map((state) => {
          if (!state.authenticated) {
            return router.createUrlTree(['/auth-code'], {
              queryParams: { returnPath: target.url },
            });
          }
          if (state.isSecurityAdministrator) {
            return (
              page === 'security-administrator' ||
              router.createUrlTree(['/security-administrator'], {
                queryParams: { returnPath: target.url },
              })
            );
          }
          if (state.profileStatus === 'forbidden') {
            return page === 'no-access' || router.createUrlTree(['/no-access']);
          }
          if (state.profileStatus === 'failed') {
            return router.createUrlTree(['/auth-code']);
          }
          return (
            page !== 'security-administrator' ||
            router.parseUrl(
              localReturnPath(_route.queryParamMap.get('returnPath')) ?? '/',
            )
          );
        }),
      );
  };
}

export const authGuard = sessionGuard('application');
export const securityAdministratorGuard = sessionGuard(
  'security-administrator',
);
export const noAccessGuard = sessionGuard('no-access');
